<template>
  <div
    id="navigationPanel"
    class="flexContainer yCenterContainer fullContainer"
  >
    <router-link :to="homeUrl"><img :src="homeButtonSrc" /></router-link>
    <button class="linkAlike blueButton" @click="showLetsGoPopup">
      chodźmy
    </button>
    <button class="linkAlike orangeButton" @click="showCreatePopup">
      twórz
    </button>
    <button class="linkAlike blueButton" @click="showSearchPopup">
      dokąd?
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      homeButtonSrc:
        process.env.VUE_APP_STATIC_HOST + "/static/buttons/home.gif",
      homeArticleId: null,
      homeArticleTitle: null,
    };
  },
  created() {
    this.$http.get("first/").then((response) => {
      let responseData = response.data;
      this.homeArticleId = responseData.id;
      this.homeArticleTitle = responseData.title;
    });
  },
  computed: {
    homeUrl() {
      return this.homeArticleTitle + "-" + this.homeArticleId;
    },
  },
  methods: {
    showCreatePopup() {
      this.$store.dispatch("sendNewPopupMessage", {
        type: "pop-up-create-vademecum",
      });
    },
    showLetsGoPopup() {
      this.$store.dispatch("sendNewPopupMessage", {
        type: "pop-up-lets-go",
      });
    },
    showSearchPopup() {
      this.$store.dispatch("sendNewPopupMessage", {
        type: "pop-up-search",
      });
    },
  },
};
</script>

<style scoped>
#navigationPanel {
  flex-direction: column;
}

@media (max-width: 1000px) {
  #navigationPanel {
    flex-direction: row;
  }
}

button {
  font-size: 22px;
  text-decoration: none;
  padding-top: 10%;
  padding-bottom: 10%;
}

button:hover {
  text-decoration: underline;
}

.blueButton:hover {
  color: #016d8f;
}

.orangeButton:hover {
  color: #ec783e;
}

a {
  padding-top: 5%;
}

@media (max-width: 1000px) {
  a {
    padding: 0;
    width: 40%;
  }

  button {
    font-size: 16px;
  }

  img {
    width: 100%;
  }

  button{
    width: 25%;
  }
}
</style>
